import { UploadFileComponent } from "Components/CommonComponents/UploadFileComponent";
import UploadPlannerFileModal from "Pages/PlannerView/UploadPlannerFile/UploadPlannerFileModal";
import React, { useState, useEffect } from "react";
import { Button } from "antd";

export interface documentInterface {
  streamList?: number | null;
  acadYearList?: number | null;
  docTypeList?: number[] | null;
  streamId: number | null;
  acadYearId: number | null;
  documentTypeId: number | null;
  classList: number[] | null;
  phaseList?: number[] | null;
  subjectList?: number[] | null;
  file?: any;
  title?: any;
}
function UploadPlannerFile({
  filterData,
  subjects,
  stream,
  acadYears,
  classes,
  docTypes,
}: any) {
  const [uploadFile, setuploadFile] = useState(null);
  const [modal, setModal] = useState<boolean>(false);
  const [filterState, setFilterState] = useState<any>({
    streamId: null,
    acadYearId: null,
    documentTypeId: null,
    classList: null,
    phaseList: null,
    subjectList: null,
    fileName: null,
    title: null,
  });

  const [filterDataValue, setFilterDataValue] = useState<documentInterface>({
    streamId: 44,
    acadYearId: 1,
    documentTypeId: 2,
    classList: [2, 3, 4],
    phaseList: [1],
    subjectList: [32, 33],
    file: null,
    title: null,
  });
  const toggle = () => setModal(!modal);
  useEffect(() => {
    console.log("filterDataValue", filterData);
    if (filterData && Object.keys(filterData).length > 0) {
      Object.keys(filterData).map((ele) => {
        const label = Array.isArray(filterData[ele])
          ? filterData[ele] && filterData[ele].map((ele: any) => ele)
            ? filterData[ele].map((ele: any) => ele)
            : null
          : filterData[ele] != null && filterData[ele]
          ? filterData[ele]
          : null;
        const value = Array.isArray(filterData[ele])
          ? filterData[ele] && filterData[ele].map((ele: any) => ele)
            ? filterData[ele].map((ele: any) => ele)
            : null
          : filterData[ele] != null && filterData[ele]
          ? filterData[ele]
          : null;
        setFilterState((prevState: any) => ({
          ...prevState,
          [ele]: label,
        }));
        setFilterDataValue((prevState: any) => ({
          ...prevState,
          [ele]: value,
        }));
      });
      setFilterState((prevState: any) => ({
        ...prevState,
        ["title"]: filterData.title,
      }));
      setFilterDataValue((prevState: any) => ({
        ...prevState,
        ["title"]: filterData.title,
      }));
    }
  }, [filterData]);
  const handleFileupload = (file: any) => {
    setuploadFile(file);
    setFilterState((prevState: any) => ({
      ...prevState,
      fileName: file?.name,
    }));
    setFilterDataValue((prevState: any) => ({
      ...prevState,
      file: file,
    }));
  };
  const isDisabledReturn = () => {
    console.log("filterData===", filterData, uploadFile);
    if (uploadFile == null) {
      return true;
    } else if (filterData["streamId"] == null) {
      return true;
    } else if (filterData["acadYearId"] == null) {
      return true;
    } else if (
      filterData["classList"] == null ||
      filterData["classList"].length == 0
    ) {
      return true;
    } else if (filterData["documentTypeId"] == null) {
      return true;
    } else if (filterData["title"] == null || filterData["title"] == "") {
      return true;
    } else {
      return false;
    }
  };
  return (
    <div className="d-flex flex-column">
      <UploadFileComponent onSelectFile={(e: any) => handleFileupload(e)} />
      <div className="d-flex justify-content-center align-items-center mt-4 mb-4">
        <Button
          disabled={isDisabledReturn()}
          type={isDisabledReturn() ? "default" : "primary"}
          onClick={toggle}
        >
          Upload
        </Button>
      </div>
      <UploadPlannerFileModal
        filterDataValue={filterDataValue}
        filterState={filterState}
        uploadFile={uploadFile}
        modal={modal}
        toggle={toggle}
        subjects={subjects}
        stream={stream}
        acadYears={acadYears}
        classes={classes}
        docTypes={docTypes}
      />
    </div>
  );
}

export default UploadPlannerFile;
